import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { LoaderComponent } from './loader/loader.component';
import { AlertComponent } from './alert/alert.component';
import { ServicesModule } from 'src/services/services.module';
import { FooterComponent } from './footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeOverlayComponent } from './home-overlay/home-overlay.component';
import { HandleCallWaiterComponent } from './handle-call-waiter/handle-call-waiter.component';
import { HandleSelfOrderComponent } from './handle-self-order/handle-self-order.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TableFormComponent } from './table-form/table-form.component';
import { BaseCardComponent } from './base-card/base-card.component';
import { DishItemsComponent } from './dish-items/dish-items.component';
import { DishDetailsComponent } from './dish-details/dish-details.component';
import { OrderItemComponent } from './order-item/order-item.component';
import { RouterModule } from '@angular/router';
import { OrderItemsComponent } from './order-items/order-items.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { CheckoutOptionsComponent } from './checkout-options/checkout-options.component';
import { ChangeDishTextPipe } from 'src/services/pipes/changeDishText/change-dish-text.pipe';

@NgModule({
  declarations: [
    AlertComponent,
    LoaderComponent,
    FooterComponent,
    HomeOverlayComponent,
    HandleCallWaiterComponent,
    HandleSelfOrderComponent,
    TableFormComponent,
    BaseCardComponent,
    DishItemsComponent,
    DishDetailsComponent,
    OrderItemComponent,
    OrderItemsComponent,
    CheckoutOptionsComponent,
    ChangeDishTextPipe,
  ],
  imports: [
    CommonModule,
    ServicesModule,
    NgbModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatBottomSheetModule,
    MatMenuModule,
    NgSelectModule,
    MatTooltipModule,
    MatExpansionModule,
  ],
  exports: [
    AlertComponent,
    LoaderComponent,
    BaseCardComponent,
    NgbModule,
    TableFormComponent,
    DishItemsComponent,
    DishDetailsComponent,
    OrderItemComponent,
    OrderItemsComponent,
    MatMenuModule,
    MatTooltipModule,
    MatExpansionModule,
    FormsModule,
  ],
  entryComponents: [
    HomeOverlayComponent,
    HandleCallWaiterComponent,
    HandleSelfOrderComponent,
  ],
})
export class SharedModule {}
